import AgenciesList from "../../components/Agencies/AgenciesList";

const agenciesRoutes = [
    {
        path: '', name: 'agenciesList', component: AgenciesList,
    },
];

export default agenciesRoutes;
